import { Component } from '@angular/core';
import { MENU_PAGE } from '../shared/defines/desktop.const';

@Component({
  selector: 'app-reference',
  templateUrl: './reference.component.html',
  styleUrls: ['./reference.component.scss']
})
export class ReferenceComponent {


  MENU_PAGE = MENU_PAGE;
}
